<div class="my-3">HI comparison for previous 50 samples</div>
<app-dvs-chart [options]="boxPlotOptions" [error]="plotError"></app-dvs-chart>